export default __webpack_public_path__ + "static/media/heroImg.a5c2e9e3.png";